<template>
  <div>
    <topIcon :template="dominItem.templateId"  :nationId="dominItem.nationId" color="#E2001A"></topIcon>
    <van-loading type="spinner" v-if="nodata"/>
    <div style="background: #ffffff;">
      <div class="logo" v-if="dominItem.templateId === 'temp1'">
        {{ dominItem.logoName || 'Logo' }}
        <div class="category" >
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
        </div>
      </div>

      <div class="logo" v-if="dominItem.templateId === 'temp2'">
        <div class="category" >
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
        </div>
        {{ dominItem.logoName || 'Logo' }}
      </div>

      <div class="logo" style="display: flex; flex-direction: column"  v-if="dominItem.templateId === 'temp3'">
        {{ dominItem.logoName || 'Logo' }}
        <div class="category" >
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
        </div>

      </div>
    </div>


    <div style="padding: 0 10%;">
      <div class="news-page">
        <!-- 最新新闻区域 -->
        <div class="latest-news-section">
          <h2 class="section-title" style="width: 1200px; margin: auto; margin-bottom: 30px">
            <span class="bgSpan">{{ $t('con_recommended') }}</span>
          </h2>
          <div class="news-grid" >
            <!-- 左侧大图新闻 -->
            <div class="news-large" @click="toDetail(bestItem.articleShortName)">
              <div class="news-image-container">
                <img :src="bestItem.articleImage" />
              </div>
              <h3 class="twoHde"  style="margin-left: 20px">{{ bestItem.articleTitle }}</h3>
              <p class="news-excerpt small "  style="margin-left: 20px; margin-bottom: 10px">
                {{ bestItem.articleIntro }}</p>
<!--              <div class="news-meta" >-->
<!--                <span>{{ bestItem.uploadTime }}</span>-->
<!--              </div>-->
            </div>

            <!-- 右侧新闻列表 -->
            <div class="news-list">
              <div v-for="(item, index) in articleList" :key="item.id" class="news-item" @click="toDetail(item.articleShortName)">
                <div class="news-item-content">
                  <img :src="item.articleImage" />
                  <h4 class="twoHde" style="margin-left: 0">{{ item.articleTitle }}</h4>
<!--                  <div class="news-meta small"  style="margin-left: 0">-->
<!--                    <span>{{ item.uploadTime }}</span>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 热门新闻区域 -->
        <div class="popular-news-section">
          <h2 class="section-title">
            <span class="bgSpan">{{ $t('con_hot_con') }}</span></h2>
          <div class="popular-grid">
            <div v-for="(item, index) in articleList2" :key="item.id" class="popular-item" @click="toDetail(item.articleShortName)">
              <div class="popular-image-container">
                <img :src="item.articleImage" />
              </div>
              <h4 class="twoHde">{{ item.articleTitle }}</h4>
<!--              <div class="news-meta small">-->
<!--&lt;!&ndash;                <span>{{ item.uploadTime }}</span>&ndash;&gt;-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>
        <div class="but-box">
          <div class="health-section">
            <h2 class="section-title">
              <span class="bgSpan">{{ $t('con_latest') }}</span></h2>
            <div class="health-cards">
              <div class="health-card" v-for="(item, index) in articleList3"
                   :key="item.id" @click="toDetail(item.articleShortName)">
                <div class="card-image">
                  <img :src="item.articleImage">
                </div>
                <h3 class="card-title threeHde">{{ item.articleTitle }}</h3>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div class="buttom">
      <div class="kuai">
      <div class="btn-logo">{{ dominItem.logoName || 'Logo' }}
        <div style="display: flex; align-items: center">
        <img class="imgsss" v-if="dominItem.nationId !== 'cn'" v-for="item in iconListsmall" @click="openLink(item.link)" :src="item.url" alt="">
        </div>
      </div>
      <div class="explore">
        <span v-for="item in typeList" @click="changeType(item.id)" style="cursor: pointer; color: #ffffff">{{ item.label }}</span>
      </div>
      <footers is00="is04" color="#ffffff" widd="none" :articleListlast="articleListlast" :current="current"></footers>
      </div>
    </div>
  </div>
</template>

<script>
import {getOne, newContent} from "@/api"
import topIcon from '../../icons/small.vue'
import {format} from "date-fns";
import buttomIcon from '../../icons/big.vue'
import footers from "@/components/footContent/index.vue"

export default {
  components: {topIcon, buttomIcon, footers},


  props: {
    dominItem: Object
  },

  name: "index",
  data() {
    return {
      bestItem: {},
      nodata: false,
      // template: 'temp3',
      current: 1,
      recommendList: [],
      latestNewsList: [],
      articleList: [],
      articleList1: [],
      articleList2: [],
      articleList3: [],
      articleList4: [],
      articleListlast: [],
      recommendList1: [],
      typeList: [
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_home'), id: 1},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_TECHNOLOGY'), id: 7},
        {label: this.$t('con_LIFESTYLE'), id: 5},
      ],
      iconListsmall: [
        {url: require('../../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],
    }
  },
  created() {
    this.nationId = JSON.parse(localStorage.getItem('dominItem')).nationId


    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    } else {
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    }
  },

  methods: {
    openLink(link) {
      window.open(link)
    },
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    },

    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        if (!res.data.articleImage) {
          res.data.articleImage = require('@/assets/defore.jpg')
        }
        this.bestItem = res.data
        this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
      })
    },


    // 获取推荐文章列表
    getArticleList() {
      newContent({
        articleCategoryId: this.current,
        pageNum: this.newsPageNum,
        pageSize: 4,
        articleNationId: this.nationId,
        articleType: 'con_recommended'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList = res.rows
        this.nodata = false
      })
    },


    // 获取最新文章
    getLatestNewsList() {
      newContent({
        articleCategoryId: this.current,
        pageNum: this.newsPageNum,
        pageSize: 8,
        articleNationId: this.nationId,
        articleType: 'con_latest'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList1 = res.rows
        this.newsTotal = res.total
      })
    },

    //  获取热门文章
    getRecommendList() {
      newContent({
        articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 6,

        articleNationId: this.nationId, articleType: 'con_hot_con'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList2 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList1() {
      newContent({
        articleCategoryId: this.current,
        pageNum: 1,
        pageSize: 6,
        articleNationId: this.nationId,
        articleType: 'con_bestnew'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList3 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList2() {
      newContent({
        articleCategoryId: this.current,
        pageNum: 1,
        pageSize: 9,
        articleNationId: this.nationId,
        articleType: 'con_bestnew'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList4 = res.rows
      })
    },

    // 获取最下面文章列表  相关文章
    getArticleListlast() {
      // this.nodata = true
      newContent({
        articleCategoryId: this.current,
        pageNum: 3,
        pageSize: 6,
        articleNationId: this.nationId,
        articleType: 'con_related'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  }
};
</script>

<style scoped lang="scss">
.news-page {
  padding: 30px 0;

/* 主要新闻样式 */
.main-news {
  display: flex;
  margin-bottom: 40px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
}

.main-news-image {
  flex: 1;
  min-height: 300px;
  overflow: hidden;
}

.main-news-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.main-news:hover .main-news-image img {
  transform: scale(1.05);
}

.main-news-content {
  flex: 1;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.category-badge {
  display: inline-block;
  padding: 5px 15px;
  background: #004F8B;
  color: white;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 15px;
  border-radius: 4px;
}

.category-badge.overlay {
  position: absolute;
  top: 15px;
  left: 15px;
  z-index: 1;
}

.category-badge.small {
  padding: 3px 10px;
  font-size: 12px;
  margin-bottom: 10px;
}

.main-news-content h1 {
  font-size: 28px;
  margin-bottom: 20px;
  color: #333;
  line-height: 1.3;
}

.news-excerpt {
  color: #666;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-excerpt.small {
  font-size: 14px;
  -webkit-line-clamp: 3;
}

.news-meta {
  display: flex;
  align-items: center;
  color: #999;
  font-size: 14px;
}

.news-meta span {
  margin-right: 20px;
}

.news-meta .read-more {
  color: #004F8B;
  font-weight: 500;
  margin-left: auto;
}

.news-meta.small {
  font-size: 12px;
}

/* 最新新闻区域 */
.latest-news-section {
  margin-bottom: 50px;
}

  .section-title {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 25px;
    color: #fff;
    padding-bottom: 10px;
    border-bottom: 1px solid #e0e0e0;
    text-transform: uppercase;
    letter-spacing: 1px;


  }

.news-grid {
  display: flex;
  max-width: 1200px;
  margin: auto;
  gap: 30px;
}

.news-large {
  flex: 1;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.3s ease;
}

.news-large:hover {
  transform: translateY(-5px);
}

.news-image-container {
  position: relative;
  height: 400px;
  overflow: hidden;
}

.news-image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.news-large:hover .news-image-container img {
  transform: scale(1.05);
}

.news-large h3 {
  font-size: 20px;
  margin-top: 10px;
  color: #333;
  line-height: 1.3;
}

.news-large .news-excerpt {
  margin-top: 10px;
  margin-bottom: 0;
}

.news-large .news-meta {
  padding: 0 20px 20px;
  border-top: 1px solid #eee;
  margin: 0 20px;
  padding-top: 15px;
}

.news-list {
  flex: 1;
  display: flex;
  gap: 15px;
  justify-content: space-between;
  flex-wrap: wrap;
}

.news-item {
  background: #fff;
  width: 48%;
  padding: 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  border-left: 3px solid transparent;

  img {
    width: 100%;
    height: 160px;
    object-fit: cover;
  }
}

.news-item:hover {
  transform: translateX(5px);
  border-left: 3px solid #E2001A;
}

.news-item h4 {
  font-size: 16px;
  color: #333;
  margin-top: 10px;
  margin-bottom: 10px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 热门新闻区域 */
.popular-news-section {
  margin:0 auto  40px;
  max-width: 1200px;
}

.popular-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.popular-item {
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.3s ease;
}

.popular-item:hover {
  transform: translateY(-5px);
}

.popular-image-container {
  height: 250px;
  overflow: hidden;
}

.popular-image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.popular-item:hover .popular-image-container img {
  transform: scale(1.05);
}

.popular-item .category-badge {
  margin: 15px 15px 10px;
}

.popular-item h4 {
  font-size: 16px;
  margin: 10px 20px;
  color: #333;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.popular-item .news-meta {
  padding: 0 15px 15px;
  border-top: 1px solid #eee;
  margin: 0 15px;
  padding-top: 10px;
}
}

.but-box {
  padding: 30px 0;

/* 健康板块样式 */
.health-section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 25px;
  color: #333;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.health-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.health-card {
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.health-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.card-image {
  position: relative;
  height: 220px;
  overflow: hidden;
  margin-bottom: 15px;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.health-card:hover .card-image img {
  transform: scale(1.05);
}

.card-title {
  font-size: 18px;
  line-height: 1.4;
  margin-bottom: 10px;
  color: #333;
  font-weight: 600;
}

.card-excerpt {
  color: #666;
  font-size: 15px;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
}


.logo {
  width: 1200px;
  margin: 10px auto;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  font-size: 40px;
  color: #E2001A;

  justify-content: space-between;
  font-weight: bold;
  text-align: left;
}

.logo-temp1 {
  padding: 0 20px 0 10%;
}

.logo-temp2 {
}

.category {
  min-height: 40px;
  //margin-bottom: 30px;
  color: #000000;
  font-weight: bold;
  //border-top: 2px solid var(--themeColor);
  border-bottom: 2px solid #E6E8EA;
  line-height: 38px;

  span {
    font-weight: 500;
    font-size: 18px;
    display: inline-block;
    padding: 0 20px;
    cursor: pointer;
    position: relative;
    border-bottom: 3px solid #ffffff;
  }

  span:hover {
    color: #E2001A;
    background: #eeeeee;
    transition: all .1s ease;
    border-bottom: 3px solid #E2001A;
  }

  .choose {
    transition: all .1s ease;
    color: #000000;
    border-bottom: 3px solid #E2001A;
  }
}

.buttom {
  background: #000000;
  border-top: 4px solid #E2001A;
  display: flex;
  flex-direction: column;

  .kuai {
    width: 1260px;
    margin: auto;
  }

  .btn-logo {
    margin-left: 50px;
    font-size: 40px;
    color: #ffffff;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: transparent;
  }
  .explore {
    display: flex;
    margin-left: 50px;
    margin-top: 30px;
    margin-bottom: 20px;
    align-items: center;
    font-weight: bold;
    span {
      margin-right: 10px;
      font-size: 15px;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #ffffff;
  background: #000000;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  display: flex;
  flex-wrap: wrap;

  span {
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

.imgsss {
  width: 30px;
  height: 30px;
}

.imgsss:nth-child(4) {
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(5) {
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(3) {
  width: 40px;
  height: 40px;
}

.article-image1 {
  width: 80px;
  height: 80px;
  object-fit: cover;
}
.bgSpan {
  color: #ffffff;
  border-radius: 5px;
  border: 1px solid red;
  display: inline-block;
  padding: 5px 10px;
  background: #E2001A;
}

</style>